import React from 'react';
import HeaderComponent from '../../components/Header';

const HeaderContainer= (props)=>{
    return <HeaderComponent {...props} />;
};

export default HeaderContainer;